import { GetServerSideProps, NextPage } from 'next'

import { PageSignupOrganization } from 'src/components/pages/PageSignupOrganization'
import { getSubdomainFromHost } from 'src/fixtures/utils/url'

type InitialProps = {}

type Props = {} & InitialProps

const Index: NextPage<Props> = (_: Props) => {
  return <PageSignupOrganization />
}

export default Index

export const getServerSideProps: GetServerSideProps = async ctx => {
  const subdomain = getSubdomainFromHost(ctx.req.headers.host)
  if (!subdomain || subdomain === 'app') return { props: {} }
  return { redirect: { destination: '/signin', permanent: false } }
}
